<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div v-if="showPasswordResetNotice" class="alert-warning d-flex justify-content-between align-items-center mb-3" style="border-radius: 5px;">
                    <span class="ms-3 text-white">                        
                        {{ $t('dashboard.You_are_using_a_temporary_password_Do_you_want_to_change_it_now') }}
                    </span>
                    <div class="ms-auto me-3 d-flex gap-2">
                        <router-link :to="{ path: '/profile' }" class="btn btn-sm bg-gradient-success" style="margin-top: 10px;">                        
                            {{ $t('dashboard.Yes_change_password') }}
                        </router-link>
                        <button @click="markPasswordAsPermanent" class="btn btn-sm btn-outline-light" style="margin-top: 10px;">                        
                            {{ $t('dashboard.No_donot_ask_again') }}
                        </button>
                    </div>
                </div>
                <component :is="currentDashboardComponent" />
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import AdminDashboard from './components/AdminDashboard.vue'
import KeeperDashboard from './components/KeeperDashboard.vue'
import InspectorDashboard from './components/InspectorDashboard.vue'
import AssociationAdminDashboard from './components/AssociationAdminDashboard.vue'

export default {
    name: 'Dashboard_page',
    components: {
        AdminDashboard,
        KeeperDashboard,
        InspectorDashboard,
        AssociationAdminDashboard
    },
    data() {
        return {
            searchText: '',   
            userActions: [],
            loginlogs: [],
            gets: [],            
            userLoginLog: [],
            showPasswordResetNotice: false
        }
    },
    computed: {   
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        currentDashboardComponent() {
            switch (this.userRoleName) {
                case 'Admin': return 'AdminDashboard'
                case 'Keeper': return 'KeeperDashboard'
                case 'Inspector': return 'InspectorDashboard'
                case 'AssociationAdmin': return 'AssociationAdminDashboard'
                default:
                return {
                    template: `<p>Role not recognized.</p>`
                }
            }
        }
    },
    async mounted() {
        if (this.$store.state.user?.isTemporaryPassword) {
            this.showPasswordResetNotice = true;
        }
    },
    methods: {
        formatDate(dateTimeStamp) {
            return new Date(dateTimeStamp).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        },
        async markPasswordAsPermanent() {
            try {
                this.$store.commit('setShowLoading', true);
                
                const response = await axios.post('/auth/disable-temporary-password');
                this.gets = response.data;

                if (this.gets.success) {                
                    this.showPasswordResetNotice = false;                    
                    this.$store.commit('setTemporaryPasswordFlag', false);
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>

<style scoped>
.table td,
.table th {
    white-space: normal !important;
}
</style>

<style scoped>
    .table-container {
        width: 100%;
        margin: 0 auto;
        position: relative;
        /* height: 300px; */
        overflow: auto;
    }

    /* Style table */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 1em;
    }

    thead {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    thead td {
        background-color: #fff;         
        /* padding: 1rem 0.5rem;       */  
        border-bottom: 2px solid #ddd;
    }

    .well-header3 {
        font-size: 22px;
        margin: 0 0 0 -8px;
        padding-left: 10px;
        border-left: 10px solid;
        border-color: #586ca5;
    }

    .dashboardNoOfRecords {
        font-size: 12px;
    }
    .dashboardNoOfRecords {
        font-size: 12px;
        font-weight: normal;
    }
</style>